export const INDUSTRY_GROUP_GICS_LABEL = 'Industry Group (L2)'
export const ISSUE_TYPE_144A = '144A'
